import React from 'react';
import { Space } from "antd";
import './styles.scss';


const PageHeader = (props) => {
    const {
        categoryName = "",
        pageName = "",
    } = props;

    return (
        <Space direction="vertical" size="small" block="true">
            <h2 className="header-letter-spacing">{pageName}</h2>
        </Space>
    );
};

export default PageHeader;
